
const News = ({ postCategories: _postCategories }) => {
    return null;
}

export default News;
